import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import ClientRoutes from "./Routes";
import { getUnAuthRedirectPath } from "./unAuthRedirect";
import MainUnAuth from "../components/unAuth/MainUnAuth";
import Invitation from "../components/common/invitation/Invitation";
import SuccessPage from "../components/common/payments/SuccessPage";
import SelfInvitation from "../components/common/invitation/SelfInvitation";
import MainUnAuthSBS from "../components/unAuth/MainUnAuthSBS";
import MainUnAuthCG from "../components/unAuth/MainUnAuthCG";
import MainUnAuthTI from "../components/unAuth/MainUnAuthTI";
import MainUnAuthDIY from "../components/unAuth/MainUnAuthDIY";
import Invitation33 from "../components/common/invitation/Invitation33";
import MainUnAuthWD from "../components/unAuth/MainUnAuthWD";
import MainUnAuthTipTop from "../components/unAuth/MainUnAuthTipTop";
import MainUnAuthDubi from "../components/unAuth/MainUnAuthDubi";
import UserPaymentFailed from "../components/common/payments/UserPaymentFailed";
import UserPaymentSuccess from "../components/common/payments/UserPaymentSuccess";

const DefaultRedirect = () => {
  return <Redirect to={getUnAuthRedirectPath()} />;
};

const UnAuthSwitch = () => {
  return (
    <Switch>
      <Route
        exact={true}
        path={ClientRoutes.UnAuth.main}
        component={(props) => <MainUnAuth {...props} />}
      />
      <Route
        exact={true}
        path={ClientRoutes.UnAuth.mainSBS}
        component={(props) => <MainUnAuthSBS {...props} />}
      />
      <Route
        exact={true}
        path={ClientRoutes.UnAuth.mainDIY}
        component={(props) => <MainUnAuthDIY {...props} />}
      />
      <Route
        exact={true}
        path={ClientRoutes.UnAuth.mainCG}
        component={(props) => <MainUnAuthCG {...props} />}
      />
      <Route
        exact={true}
        path={ClientRoutes.UnAuth.mainTI}
        component={(props) => <MainUnAuthTI {...props} />}
      />
      <Route
        exact={true}
        path={ClientRoutes.UnAuth.mainTipTop}
        component={(props) => <MainUnAuthTipTop {...props} />}
      />
      <Route
        exact={true}
        path={ClientRoutes.UnAuth.mainDubi}
        component={(props) => <MainUnAuthDubi {...props} />}
      />
      <Route
        exact={true}
        path={ClientRoutes.UnAuth.mainWD}
        component={(props) => <MainUnAuthWD {...props} />}
      />
      <Route
        path={ClientRoutes.UnAuth.invitation}
        component={(props) => <Invitation {...props} />}
      />
      <Route
        path={ClientRoutes.UnAuth.invitation33}
        component={(props) => <Invitation33 {...props} />}
      />
      <Route
        path={ClientRoutes.UnAuth.selfInvitation}
        component={(props) => <SelfInvitation {...props} />}
      />
      <Route
        exact={true}
        path={ClientRoutes.UnAuth.payment}
        component={(props) => <SuccessPage {...props} />}
      />
      <Route
        path={ClientRoutes.UnAuth.paymentFailed}
        component={(props) => <UserPaymentFailed {...props} />}
      />
      <Route
        path={ClientRoutes.UnAuth.paymentSuccess}
        component={(props) => <UserPaymentSuccess {...props} />}
      />
      <Route exact path="/" component={DefaultRedirect} />
      {/* catch-all: כשהמשתמש לא מחובר והאפליקציה נפתחת עם URL ישן (למשל /user/main) – מפנה לעמוד התחברות, פותר מסך לבן ב-PWA */}
      <Route component={DefaultRedirect} />
    </Switch>
  );
};

export default UnAuthSwitch;
